<template>
 <div class="t-page t-page--v2">
  <div class="t-page__content">
   <div class="t-page__main">
     <Axes :titleClass="t-page__title" />
   </div>
   <div class="t-page__side">
     <div class="side-list-2">
      <ul>
        <li>
          <h4>Les Axes</h4>
          <div>
            <a href="#menu-1">{{ $t('aboutAxis.infrastructureTitle') }} (IN)</a>
          </div>
          <div>
            <a href="#menu-2">{{ $t('aboutAxis.humanResourcesTitle') }} (RH)</a>
          </div>
          <div>
            <a href="#menu-3">{{ $t('aboutAxis.processFlowTitle') }} (AP)</a>
          </div>
          <div>
            <a href="#menu-4">{{ $t('aboutAxis.salesProductsTitle') }} (SC)</a>
          </div>
        </li>
      </ul>
      </div>
   </div>
  </div>
  <div class="t-page__bottom">
   <div class="result-bar" v-if="isAuthenticated && resultsUrl">
    <div class="result-bar__content">
    <router-link class="btn" :to="{ path:resultsUrl}">{{ $t('resources.backToResult') }}</router-link>
    </div>
   </div>
  </div>
 </div>
</template>

<script>
import Axes from '@/components/Axes.vue';

export default {
  name: 'AboutAxis',
  components: {
    Axes,
  },
};
</script>
